import type {Parser} from '../parsers/Parser.ts';

export class LocalStorage<T> {
    private parser: Parser<T>;
    private key: string;

    public constructor(key: string, parser: Parser<T>) {
        this.parser = parser;
        this.key = key;
        this.drop();
    }
    public set(value: T[]): void {
        window.localStorage.setItem(this.key, JSON.stringify(value));
    }

    private async drop(): Promise<void> {
        // Instead of clearing all localStorage, only remove old date entries
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
        const keysToRemove: string[] = [];
        
        for (let i = 0; i < window.localStorage.length; i++) {
            const key = window.localStorage.key(i);
            if (key && key.match(/^\d{4}-\d{2}-\d{2}$/) && key !== today) {
                // This is a date key that's not today, mark for removal
                keysToRemove.push(key);
            }
        }
        
        // Remove old date entries
        keysToRemove.forEach(key => window.localStorage.removeItem(key));
    }

    public get(): T[] | undefined {
        const raw = window.localStorage.getItem(this.key);
        if (!raw) return undefined;
        try {
            return JSON.parse(raw).map((item: object) => this.parser.parse(item));
        } catch {
            return undefined;
        }
    }

    public remove(): void {
        localStorage.removeItem(this.key);
    }

    public clear(): void {
        localStorage.clear();
    }
}
